import React from "react";

import "./Breadcrumb.css";

export const Breadcrumb = ({breadcrumb, color, shiftLeftBy, zIndex, navigateTo}) => {

    const handleClick = () => {
        navigateTo(breadcrumb.screenKey);
    }

    return (
        <div className="breadcrumb-container" style={{transform: `translateX(${shiftLeftBy}px)`, zIndex: zIndex}}
             aria-label={"breadcrumb-button"} onClick={handleClick}>
            <div className="breadcrumb-text-container" style={{backgroundColor: `${color}`}}>
                {breadcrumb.text && <p className="breadcrumb-text bold">{breadcrumb.text}</p>}
                <p className="breadcrumb-text">{breadcrumb.type}</p>
            </div>
            <div className="breadcrumb-arrow" style={{borderLeft: `20px solid ${color}`}}/>
        </div>
    );
}
